import { inject, Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';

import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class FirebaseService {

    private firestoreInstance: Firestore | null = inject(Firestore);
    private app: FirebaseApp | null = null;

    constructor() { }

    /**
     * Inicializa Firebase y Firestore
     */
    initialize(): void {
        if (!this.app) {
            this.app = initializeApp(environment.firebaseConfig);
            this.firestoreInstance = initializeFirestore(this.app, {});
        }
    }

    /**
     * Devuelve instancia de Firestore ya inicializada.
     */
    get firestore(): Firestore | null {
        if (!this.firestoreInstance) {
            console.error('FirebaseService not initialized. Call initialize() first.');
            return null;
        }
        return this.firestoreInstance;
    }
}
